var _class, _temp, _initialiseProps;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import * as types from "../utils/types";
import { guessType } from "../utils/";
import { isValid } from "../utils/validate";

var AnyOfField = (_temp = _class = function (_Component) {
    _inherits(AnyOfField, _Component);

    function AnyOfField(props) {
        _classCallCheck(this, AnyOfField);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _initialiseProps.call(_this);

        var _this$props = _this.props,
            formData = _this$props.formData,
            options = _this$props.options;


        _this.state = {
            selectedOption: _this.getMatchingOption(formData, options)
        };
        return _this;
    }

    AnyOfField.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
        var matchingOption = this.getMatchingOption(nextProps.formData, nextProps.options);

        if (matchingOption === this.state.selectedOption) {
            return;
        }

        this.setState({ selectedOption: matchingOption });
    };

    AnyOfField.prototype.getMatchingOption = function getMatchingOption(formData, options) {
        for (var i = 0; i < options.length; i++) {
            var option = options[i];

            // If the schema describes an object then we need to add slightly more
            // strict matching to the schema, because unless the schema uses the
            // "requires" keyword, an object will match the schema as long as it
            // doesn't have matching keys with a conflicting type. To do this we use an
            // "anyOf" with an array of requires. This augmentation expresses that the
            // schema should match if any of the keys in the schema are present on the
            // object and pass validation.
            if (option.properties) {
                // Create an "anyOf" schema that requires at least one of the keys in the
                // "properties" object
                var requiresAnyOf = {
                    anyOf: Object.keys(option.properties).map(function (key) {
                        return {
                            required: [key]
                        };
                    })
                };

                var augmentedSchema = void 0;

                // If the "anyOf" keyword already exists, wrap the augmentation in an "allOf"
                if (option.anyOf) {
                    // Create a shallow clone of the option
                    var shallowClone = _objectWithoutProperties(option, []);

                    if (!shallowClone.allOf) {
                        shallowClone.allOf = [];
                    } else {
                        // If "allOf" already exists, shallow clone the array
                        shallowClone.allOf = shallowClone.allOf.slice();
                    }

                    shallowClone.allOf.push(requiresAnyOf);

                    augmentedSchema = shallowClone;
                } else {
                    augmentedSchema = Object.assign({}, option, requiresAnyOf);
                }

                // Remove the "required" field as it's likely that not all fields have
                // been filled in yet, which will mean that the schema is not valid
                delete augmentedSchema.required;

                if (isValid(augmentedSchema, formData)) {
                    return i;
                }
            } else if (isValid(options[i], formData)) {
                return i;
            }
        }

        // If the form data matches none of the options, use the first option
        return 0;
    };

    AnyOfField.prototype.render = function render() {
        var _props = this.props,
            baseType = _props.baseType,
            disabled = _props.disabled,
            errorSchema = _props.errorSchema,
            formData = _props.formData,
            idPrefix = _props.idPrefix,
            idSchema = _props.idSchema,
            onBlur = _props.onBlur,
            onChange = _props.onChange,
            onFocus = _props.onFocus,
            options = _props.options,
            registry = _props.registry,
            safeRenderCompletion = _props.safeRenderCompletion,
            uiSchema = _props.uiSchema;


        var _SchemaField = registry.fields.SchemaField;
        var selectedOption = this.state.selectedOption;


        var option = options[selectedOption] || null;
        var optionSchema = void 0;

        if (option) {
            // If the subschema doesn't declare a type, infer the type from the
            // parent schema
            optionSchema = option.type ? option : Object.assign({}, option, { type: baseType });
        }

        return React.createElement(
            "div",
            { className: "panel panel-default panel-body" },
            React.createElement(
                "div",
                { className: "form-group" },
                React.createElement(
                    "select",
                    {
                        className: "form-control",
                        onChange: this.onOptionChange,
                        value: selectedOption,
                        id: idSchema.$id + "_anyof_select" },
                    options.map(function (option, index) {
                        return React.createElement(
                            "option",
                            { key: index, value: index },
                            option.title || "Option " + (index + 1)
                        );
                    })
                )
            ),
            option !== null && React.createElement(_SchemaField, {
                schema: optionSchema,
                uiSchema: uiSchema,
                errorSchema: errorSchema,
                idSchema: idSchema,
                idPrefix: idPrefix,
                formData: formData,
                onChange: onChange,
                onBlur: onBlur,
                onFocus: onFocus,
                registry: registry,
                safeRenderCompletion: safeRenderCompletion,
                disabled: disabled
            })
        );
    };

    return AnyOfField;
}(Component), _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.onOptionChange = function (event) {
        var selectedOption = parseInt(event.target.value, 10);
        var _props2 = _this2.props,
            formData = _props2.formData,
            onChange = _props2.onChange,
            options = _props2.options;


        var newOption = options[selectedOption];

        // If the new option is of type object and the current data is an object,
        // discard properties added using the old option.
        if (guessType(formData) === "object" && (newOption.type === "object" || newOption.properties)) {
            var newFormData = Object.assign({}, formData);

            var optionsToDiscard = options.slice();
            optionsToDiscard.splice(selectedOption, 1);

            // Discard any data added using other options
            for (var _iterator = optionsToDiscard, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var option = _ref;

                if (option.properties) {
                    for (var key in option.properties) {
                        if (newFormData.hasOwnProperty(key)) {
                            delete newFormData[key];
                        }
                    }
                }
            }

            onChange(newFormData);
        } else {
            onChange(undefined);
        }

        _this2.setState({
            selectedOption: parseInt(event.target.value, 10)
        });
    };
}, _temp);


AnyOfField.defaultProps = {
    disabled: false,
    errorSchema: {},
    idSchema: {},
    uiSchema: {}
};

if (process.env.NODE_ENV !== "production") {
    AnyOfField.propTypes = process.env.NODE_ENV !== "production" ? {
        options: PropTypes.arrayOf(PropTypes.object).isRequired,
        baseType: PropTypes.string,
        uiSchema: PropTypes.object,
        idSchema: PropTypes.object,
        formData: PropTypes.any,
        errorSchema: PropTypes.object,
        registry: types.registry.isRequired
    } : {};
}

export default AnyOfField;